import React, { useContext, useEffect, useRef, useState } from 'react';
import { Dialog, Item } from '@zebra-fed/zds-react-desktop';
import styled from 'styled-components';
import Snackbar from '@material-ui/core/Snackbar';
import { SnackbarContent } from "../../styled-components/shared";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { useTranslation } from "react-i18next";
import Select from '@material-ui/core/Select';
import {getEodCategories, EOD_CATEGORIES} from '../../data/constants'
import { SiteModel, SiteService } from "../../Services/SiteService";
import { ServerStyleSheets } from '@material-ui/core';
import { TimeZoneData } from "../../data/tzTimeZoneList";
import {isIPAddress} from 'ip-address-validator';
import Checkbox from '@material-ui/core/Checkbox';
import { DataContext } from '../../data/DataContext';
import { FieldWrapper } from '../common/FieldWrapper';



import { StyledField, StyledTextField, LabelText, ErrorLine, HeadDes, BodyContent } from "./Styles";

import { Formcontainer, SelectField, Row, PopupContainer, FooterContainer, PopupHeader, CheckBoxRow, TransBtn, BlueBtn } from "./Styles";

import { FormControlLabel } from '@material-ui/core';
import { Button, RadioButtonGroup, Switch } from "@zebra-fed/zds-react-desktop";

class SiteProps {

    modalRef;


    tenantId;

    //Callback when a device is added
    onSitesUpdated;

    //Firestone query based on the current filter
    filterQuery;

    //Based on this, all sites check box will be shown
    showAllSites;

}

const SwitchDiv = styled.div`
  padding-left: 50px;
  left: 0px;
`;

const NoBullets = styled.div`
margin: 0;
padding: 20;
list-style-type: none;
overflow-y: scroll;
height:200px;
width:300px;
border: 1px solid Silver;`;

export function SiteReportedTime(props) {
    //Site Reported time is a special one which allows
    //0-30 Mins and 00-12 hrs with AM/PM

    const { t } = useTranslation();

    const TIME_AM = 1;
    const TIME_PM = 2;

    const hrs = [
        { label: "00", value: 0 },
        { label: "30", value: 30 },
    ];


    const minutes = [
        { label: "00", value: 0 },
        { label: "01", value: 1 },
        { label: "02", value: 2 }
    ];

    const AM_PM = [
        { label: "AM", value: 1 },
        { label: "PM", value: 2 }
    ];

    // const [ reportedTime, setReportedTime] = useState({
    //     hrs: null,
    //     minutes: null,
    //     AM_PM: null
    // });


    function get2Digits(number) {
        return number > 9 ? "" + number : "0" + number;
    }


    function getReportTimeIn24HrFormat() {


        if (props.reportTime == null) {
            return "";
        }

        var hrs = props.reportTime.hrs;
        var mins = props.reportTime.minutes;

        //return in format 00:00
        var result = get2Digits(hrs) + ":" + get2Digits(mins);
        return result;
    }

    return (
        // <Formcontainer>
        //     <LabelText>{t('site.scheduledReportTime')}</LabelText>
            <FieldWrapper
                    label={props.label}
                    error={props.error}
                    helperText={props.helperText}
                    fullWidth={props.fullWidth}
                    required={props.required}
                  >
                <StyledTextField
                    id='outlined-basic'
                    variant="outlined"
                    type="time"
                    value={getReportTimeIn24HrFormat()}
                    //style={{ width: "auto" }}
                    onChange={(e) => {
                        if (e.target.value == null || e.target.value == "") {
                            //NULL value
                            props.onReportingTimeChanged(null);
                            return;
                        }

                        //Get the HRS and MINS
                        //The tiem will be in 23:54
                        var tokens = e.target.value.split(':');

                        var hours = parseInt(tokens[0]);
                        var minutes = parseInt(tokens[1]);


                        var reportTime = ({
                            //If PM, subtract to get the time in 12 hr
                            hrs: hours,
                            minutes: minutes,
                            //AM_PM: (hours > 12)? TIME_PM: TIME_AM
                        });
                        props.onReportingTimeChanged(reportTime);
                    }} />
            </FieldWrapper>
        // </Formcontainer>

    )

}

export function EditSiteModal(args) {


    var props = new SiteProps();
    props = args;

    const dialogRef = props.modalRef;

    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const errors = useRef([]);
    const [hasErrors, setHasErrors] = useState(false);
    // DLR flag
    const { dlrFeatureFlag, globalAppSettings, mlPredictionStatus } = useContext(DataContext);
    const [showDLR, setShowDLR] = useState(false);

    const [applyToAllSites, setApplyToAllSites] = useState(false);
    const {deviceRegistrationType} = props.appSetting;
    const data = props.data;
    const service = new SiteService();

    const categoriesData = getEodCategories(globalAppSettings.enableBTScannerTracking);

    useEffect(() => {
        console.log("categoriesData ", categoriesData, dlrFeatureFlag)
        if(!dlrFeatureFlag){
          // removing At Risk if dlr feature is disabled
          setShowDLR(false);
        }
        else{
          if(mlPredictionStatus)  setShowDLR(true);    // adding At Risk if ml prediction enabled
          else  setShowDLR(false);
        }
    }, [mlPredictionStatus, dlrFeatureFlag]);

    const [model, setModel] = useState({
        siteName: "",
        timeZone: "",

        scheduledReportTime: null,
        emailSubscribed: false,

        emailList: "",

        snapshotReportCategories : {
            'Select All' : false ,
            'Never Connected': false,
            'Disconnected': false,
            'Checked Out': false,
            'Low Battery': false,
            'Charging': false,
            'Decommissioned': false,
            'Discharging': false,
            'Idle': false,
            'At Risk': false,
            'To Be Found': false,
            'Being Found': false,
            'Cannot Find': false,
            'Found': false,
            'Move In/Out':false,
            [EOD_CATEGORIES["CONNECTED ACCESSORIES"]]:false
            },
        attachCSV: false
    });


    const tenantId = props.tenantId;

    const onSitesUpdated = props.onSitesUpdated;

    useEffect(() => {
        clearForm();
    }, [""]);



    function clearForm() {

        setModel({
            siteName: "",
            timeZone: "",

            scheduledReportTime: null,
            emailSubscribed: false,
            startIPAddress:"",
            endIPAddress:"",
            emailList: "",
            snapshotReportCategories : {
                'Select All' : false ,
                'Never Connected': false,
                'Disconnected': false,
                'Checked Out': false,
                'Low Battery': false,
                'Charging': false,
                'Decommissioned': false,
                'Discharging': false,
                'Idle': false,
                'At Risk': false,
                'To Be Found': false,
                'Being Found': false,
                'Cannot Find': false,
                'Found': false,
                'Move In/Out':false,
                [EOD_CATEGORIES["CONNECTED ACCESSORIES"]]:false
                },
            attachCSV: false
        });

        setApplyToAllSites(false);
        //Clear the errors
        errors.current = [];
    }

    function validateRequired(value, fieldName, validationMsgKey) {

        if(fieldName === "scheduledReportTime"){
            if (value == null) {
                //Add the required error against the field name
                errors.current.push({"fieldName": fieldName, "errorMessage":  t(validationMsgKey)});
            }
        }else{
            if (value == null || value.trim() == "") {
                //Add the required error against the field name
                errors.current.push({"fieldName": fieldName, "errorMessage":  t(validationMsgKey)});
            }
        }
    }

    function validateFieldLength(value, fieldName, maxLength, validationMsgKey) {

        if (value == null) {
            //NULL value. No need for futher validation
            return;
        }

        if (value.length > maxLength) {
            //Add the MAX length Error  against the field name
            errors.current.push({ "fieldName": fieldName, "errorMessage": t(validationMsgKey) });
            //errors[fieldName] = "Please provide a value with length less than " + maxLength;
        }
    }

    function validateFormat(value, fieldName, validationMsgKey){
        console.log('isIPAddress(value) '+isIPAddress(value))
        if(!isIPAddress(value)){
            errors.current.push({"fieldName": fieldName, "errorMessage": t(validationMsgKey)});
        }
        return;
    }

    async function validateSite() {
        errors.current = [];

        const MAX_CHARS = 32;
        const MAX_CHARS_MSG_KEY = "validation.rules.sso.rule45";
        const REQUIRED_TXT_MSG_KEY = "validation.rules.Mo_Dash.RequiredTxtMessage";
        const REQUIRED_DROPDOWN_MSG_KEY = "validation.rules.Mo_Dash.RequiredDropdownMessage";
        const EMAIL_INAVLID_KEY = "validation.rules.sso.rule46";
        const INVALID_IP_TXT_MSG_KEY = "validation.rules.Mo_Dash.InvalidIPAddress"
        const INVALID_IP_RANGE = "validation.rules.Mo_Dash.InvalidIPAddressRange"
        const IP_ADDRESS_OVERLAP = "validation.rules.Mo_Dash.IpAddressOverlap"

        //Validate each field
        //All the fields have the same MAX length. So use the same ERR MSG & MAX CHARS

        validateRequired(model.timeZone, "timeZone", REQUIRED_DROPDOWN_MSG_KEY);
        if(model.emailSubscribed){
            validateRequired(model.scheduledReportTime, "scheduledReportTime", REQUIRED_TXT_MSG_KEY);
        }

        if(deviceRegistrationType === 2) {
            validateRequired(model.startIPAddress, "startIPAddress", REQUIRED_TXT_MSG_KEY);
            validateFormat(model.startIPAddress, "startIPAddress", INVALID_IP_TXT_MSG_KEY);

            validateRequired(model.endIPAddress, "endIPAddress", REQUIRED_TXT_MSG_KEY);
            validateFormat(model.endIPAddress, "endIPAddress", INVALID_IP_TXT_MSG_KEY);

            console.log("startIPAddress", model.startIPAddress)
            console.log("endIPAddress", model.endIPAddress)
            console.log('errors.current '+JSON.stringify(errors.current))

            let errorsInIPInput = errors.current.filter(el=>{
               return  el.fieldName === 'startIPAddress' || el.fieldName === 'endIPAddress'
            })
            console.log('errorsInIPInput '+JSON.stringify(errorsInIPInput))

            //Invalid IP Range
            if(errorsInIPInput.length === 0){
                if(!SiteService.isValidIPRange(model.startIPAddress, model.endIPAddress)){
                    console.log('Valid Range')
                    errors.current.push({"fieldName": "startIPAddress", "errorMessage":  t(INVALID_IP_RANGE)});
                    errors.current.push({"fieldName": "endIPAddress", "errorMessage":  t(INVALID_IP_RANGE)});
                }else{
                    const selectedSites = props.selectedItems.map(element=>element.siteName);
                    /**
                     * remove selected sites to compare. No need to compare with self(selected item).
                    */
                    const sites = data.filter(element=>!selectedSites.includes(element.siteName));
                    await service.ipRangeOverlapping(model.startIPAddress, model.endIPAddress, sites).then(res=>{
                        console.log('ipRangeOverlapping ')
                        if(res){
                            errors.current.push({"fieldName": "startIPAddress", "errorMessage":  t(IP_ADDRESS_OVERLAP)});
                            errors.current.push({"fieldName": "endIPAddress", "errorMessage":  t(IP_ADDRESS_OVERLAP)});
                        }
                    })
                }
            }
        }

        //Validate Email
        if (!SiteService.isValidEmailList(model.emailList)) {
            //Email Invalid
            errors.current.push({ "fieldName": "emailList", "errorMessage": t(EMAIL_INAVLID_KEY) });
        }


        if (model.scheduledReportTime != null) {
            //Reported time can contain only 00/30 in MINS
            if (model.scheduledReportTime.minutes != "00" && model.scheduledReportTime.minutes != "30") {
                //Validate
                errors.current.push({
                    "fieldName": "scheduledReportTime",
                    errorMessage: t("validation.rules.Mo_Dash.InvalidScheduledTime")
                });
            }
        }

        setHasErrors(!hasErrors);
    }

    function getErrorMessage(field) {

        const error = errors.current.find((error) => error.fieldName == field);
        return error ? error.errorMessage : null;
    }

    async function updateSites() {

        //Deelete all the access points
        //Convert teh reported time to CRON expression

        if (applyToAllSites) {
            // Delete all the items. If a filter isapplied, should delete only the filtered items
            //Use the current APS query which will dleete  the current selected
            //data based on search text & other parm
            await service.updateAllSites(props.tenantId, props.filterQuery(), model);
            //Refresh data. Before that clear the selection
            onSitesUpdated();
        }
        else {
            //Delete only seleted data..
            var itemsToDelete = props.selectedItems.map((s) => {
                return {
                    "siteName": s.siteName
                };
            });

            await service.updateSites(props.tenantId, itemsToDelete, model);
            onSitesUpdated();
        }

    }


    function handleCancel() {

        //Clear the form and close it
        clearForm();
        dialogRef.current.toggleDialog();

        // clearForm();
    }

    const ButtonStyle = {
        cursor: isLoading ? 'wait' : 'pointer',
    }

    async function handleUpdateClick() {


        await validateSite();
        //dialogRef.current.toggleDialog();


        if (errors.current.length == 0) {
            //No errors..
            //Add to DB

            setIsLoading(true);

            //Add the DEVICE
            //await service.updateSites(tenantId, model);

            //Just call the function It will take care of refreshing the UI  
            await updateSites();
            setIsLoading(false);

            //Clear the form and close it
            clearForm();

            //close the dialog
            dialogRef.current.toggleDialog();

        }
    }




    function renderErrorMessage(fieldName) {
        var errMsg = getErrorMessage(fieldName);

        return (<ErrorLine style={{ display: errMsg != null ? 'block' : 'none' }}>
            {errMsg}
        </ErrorLine>);
    }

    const handleOnChange = (category) => {
        const updatedCheckedState = model.snapshotReportCategories;
        if(category==="Select All")
        {
            let final = !updatedCheckedState[category];
            for(let key in updatedCheckedState)
            {
                updatedCheckedState[key] = final;
            }
        }
        else
        {
            updatedCheckedState[category] = !updatedCheckedState[category];
            if(updatedCheckedState[category] == false)
            {
                updatedCheckedState["Select All"] = false;
            }
            if(updatedCheckedState['Never Connected'] && updatedCheckedState['Disconnected'] && updatedCheckedState['Checked Out'] && updatedCheckedState['Low Battery'] && updatedCheckedState['Charging'] && updatedCheckedState['Decommissioned'] && updatedCheckedState['Discharging'] && updatedCheckedState['Idle'] && updatedCheckedState['To Be Found'] && updatedCheckedState['Being Found'] &&updatedCheckedState['Cannot Find'] &&updatedCheckedState['Found'] && updatedCheckedState['At Risk'] && updatedCheckedState['Move In/Out'] && updatedCheckedState[EOD_CATEGORIES["CONNECTED ACCESSORIES"]]){
                updatedCheckedState['Select All'] = true;
            }
        }
        console.log(updatedCheckedState);
        setModel({ ...model, snapshotReportCategories: updatedCheckedState });
        };

    const handleattachCSV = () => {
        console.log(model.attachCSV);
        setModel({...model, attachCSV: !model.attachCSV});
        console.log(model.attachCSV);
    };

    const timeZones = TimeZoneData;



    const TIME_AM = 1;
    const TIME_PM = 2;


    function convertCRONToReportTime(cron) {
        //Convert from CRON expression..
        //CRON expression will be like * mm hh * * *
        //We set only minutes/hrs
        //If ss is *, then 
        var tokens = cron.split(" ");
        //Hrs
        var hrs = tokens[2] == "*" ? null : parseInt(tokens[2]);
        //Miniutes
        var minutes = tokens[1] == "*" ? null : tokens[1];
        //AM/PM
        var ampm = TIME_AM;

        if (hrs > 12) {
            //PM
            ampm = TIME_PM;
            hrs = hrs - 12;
        }
        return {
            minutes: minutes, //SECS
            hrs: hrs,
            AM_PM: ampm
        };
    }


    function convertToBoolean(value) {
        if (value == null || value == "") {
            return null;
        }
        else {
            return (value == "true");
        }
    }


    return (
        <div>
            <Dialog
                ref={dialogRef}
                key='dialog255'
                width='520px'
                headerStyle={{ display: 'none' }}
                bodyStyle={{ padding: '0px', width: '100%' }}
                cardStyle={{ marginBottom: '20px' }}
                footerStyle={{ display: 'none' }}
                items={[]}>
                <PopupContainer>
                    <PopupHeader>{t('site.updateTitle')}</PopupHeader>
                    <HeadDes>{t('manual')}</HeadDes>
                    <BodyContent>
                        <form noValidate
                            style={{ pointerEvents: isLoading ? 'none' : '' }}>
                            {
                            deviceRegistrationType === 2 && <>
                             <Formcontainer>
                                <LabelText>{t('site.startIPAddress')}</LabelText>
                                <StyledTextField
                                    id='outlined-basic'
                                    variant="outlined"
                                    error={ getErrorMessage("startIPAddress") }
                                    onChange={(e) => setModel({ ...model, startIPAddress: e.target.value })}
                                    placeholder="Start IP Address"
                                    value={model.startIPAddress}

                                />
                                {  renderErrorMessage("startIPAddress") }
                            </Formcontainer>

                            <Formcontainer>
                                <LabelText>{t('site.endIPAddress')}</LabelText>
                                <StyledTextField
                                    id='outlined-basic'
                                    variant="outlined"
                                    error={ getErrorMessage("endIPAddress") }
                                    onChange={(e) => setModel({ ...model, endIPAddress: e.target.value })}
                                    placeholder="End IP Address"
                                    value={model.endIPAddress}

                                />
                                {  renderErrorMessage("endIPAddress") }
                            </Formcontainer>
                            </>
                        }

                            <Formcontainer>
                                <LabelText>{t('site.timeZone')}</LabelText>
                                <SelectField
                                    native
                                    variant="outlined"
                                    value={model.timeZone}
                                    onChange={(e) => setModel({ ...model, timeZone: e.target.value })
                                    }
                                    error={getErrorMessage("timeZone")}>
                                    <option value={null}>{t('Select')}</option>
                                    {
                                        timeZones.map((tz) => {
                                            return (<option value={tz.tzDatabaseName}>{tz.tzDatabaseName}</option>);
                                        })
                                    }
                                </SelectField>
                                {renderErrorMessage("timeZone")}
                            </Formcontainer>
                                                    
                            <Formcontainer>
                                <FormControlLabel
                                    classes="onOffSwitch"
                                    control={<SwitchDiv>
                                        <Switch color="primary"
                                            checked={model.emailSubscribed} value={model.emailSubscribed}
                                            onChange={(value) => setModel({ ...model, emailSubscribed: value })}
                                        />
                                    </SwitchDiv>}
                                    label={<LabelText>{t('site.emailSubscribed')}</LabelText>}
                                    labelPlacement="start"
                                    style={{ marginLeft: '0', float: 'left' }} />
                            </Formcontainer>

                            {model.emailSubscribed &&
                            <Formcontainer>
                                <SiteReportedTime  reportTime={model.scheduledReportTime}
                                    onReportingTimeChanged ={
                                    (reportTime) => {
                                        //Update the Model
                                        setModel({
                                            ...model,
                                            scheduledReportTime: reportTime
                                        });
                                    }
                                } />
                                {renderErrorMessage("scheduledReportTime")}
                            </Formcontainer>
                            }
                            
                            
                            {/* <Formcontainer>
                            <LabelText>{t('site.emailSubscribed')}</LabelText>
                            <SelectField
                                native 
                                variant='outlined'
                                value={model.emailSubscribed}
                                onChange={(e) => {
                                    
                                    setModel({ ...model, emailSubscribed: convertToBoolean(e.target.value)})}}>
                                    <option value={null}></option>
                                    <option value={true}>Yes</option>
                                    <option value={false}>No</option>
                            </SelectField>
                            {  renderErrorMessage("emailSubscribed") }
                        </Formcontainer> */}


                            { /* 05/05: Internal Bugfix. Show emailList only when emailSubscrion is YES */}
                            {(model.emailSubscribed) &&
                                <Formcontainer>
                                    <LabelText>{t('site.emailList')}</LabelText>
                                    <StyledTextField
                                        rows={2}
                                        maxRows={2}
                                        multiline={true}
                                        id='outlined-basic'
                                        variant="outlined"
                                        error={getErrorMessage("emailList")}
                                        onChange={(e) => setModel({ ...model, emailList: e.target.value })}
                                        placeholder={t('Mo_Dash.placeholders.enter_email')}
                                        value={model.emailList}

                                    />
                                    {renderErrorMessage("emailList")}
                                </Formcontainer>
                            }

                            {props.showAllSites &&
                                (<Formcontainer>
                                    <Row>
                                        <Checkbox
                                            checked={applyToAllSites}
                                            color="primary"
                                            onChange={(e) => {
                                                setApplyToAllSites(e.target.checked);
                                            }
                                            }
                                            name="deviceRow" />
                                        <p>{t("updateAllRecordsConfirmMsg")}</p>
                                    </Row>
                                </Formcontainer>)
                            }

                            
                            <Formcontainer>
                                <LabelText>{t('site.emailCriteria')}</LabelText>
                                <div
                                    id='outlined-basic'
                                    variant="outlined"
                                    value={model.snapshotReportCategories}
                                    error={ getErrorMessage("emailCriteria")}>
                                    <NoBullets>
                                    {categoriesData.map((category, index) => {
                                        if(category.value == "At Risk" && !showDLR){
                                            return null;
                                        }
                                        return (
                                            <li key={index}>
                                                <div>
                                                <Checkbox
                                                    name={category.value}
                                                    value={category.value}
                                                    checked={model.snapshotReportCategories[category.value]}
                                                    onChange={() => handleOnChange(category.value)}
                                                />
                                                <label>{category.label}</label>
                                                </div>
                                            </li>
                                        );
                                    })}
                                    </NoBullets>
                                </div>
                                {  renderErrorMessage("emailCriteria") }
                            </Formcontainer>
                            
                            {model.emailSubscribed?
                            <Formcontainer>
                                <div className="Attachments">
                                    <Checkbox
                                    checked={model.attachCSV}
                                    onChange={handleattachCSV}
                                    />
                                    {t('site.attachCSV')}
                                </div>
                            </Formcontainer>
                            :
                            <Formcontainer>
                                <div className="Attachments">
                                    <Checkbox
                                    disabled
                                    checked={model.attachCSV}
                                    onChange={handleattachCSV}
                                    />
                                    {t('site.attachCSV')}
                                </div>
                            </Formcontainer>
                            }

                        </form>
                    </BodyContent>
                    <FooterContainer style={{ pointerEvents: isLoading ? 'none' : '' }}>
                        <TransBtn onClick={() => { handleCancel(); }}>{t('cancel')}</TransBtn>
                        <BlueBtn onClick={() => { handleUpdateClick(); }}>{isLoading ? t('workingOnIt') : t('Confirm')}</BlueBtn>
                    </FooterContainer>
                </PopupContainer>

            </Dialog>
        </div>
    )
} 